import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-new-acc-guide',
  templateUrl: './new-acc-guide.component.html',
  styleUrls: ['./new-acc-guide.component.scss']
})
export class NewAccGuideComponent implements OnInit {
  constructor() { }

  ngOnInit(): void {
  }

}
